import React from "react";
import Feature from "../../components/feature/Feature";
import "./features.css";

const featuresData = [
  {
    title: "Custom Software Development",
    text: "From web and mobile applications to enterprise-grade solutions, we specialize in developing bespoke software tailored to your specific requirements and objectives.",
  },
  {
    title: "UX/UI Design ",
    text: "We believe that great design is more than just aesthetics, its about creating intuitive, engaging, and user-centric experiences that captivate and delight. Our UX/UI design services are geared towards creating seamless digital experiences that leave a lasting impression.",
  },
  {
    title: "Cloud Solutions",
    text: " Embrace the power of the cloud with our scalable, secure, and cost-effective cloud solutions. Whether you're looking to migrate to the cloud, optimize your cloud infrastructure, or develop cloud-native applications, we've got you covered. ",
  },
  {
    title: "Digital Transformation",
    text: "Embrace the future with confidence with our digital transformation services. From legacy modernization and process automation to IoT integration and AI-driven insights, we help you navigate the complexities of digital transformation, empowering you to stay ahead of the curve and seize new opportunities in a rapidly evolving digital landscape. ",
  },
];

const Features = () => {
  return (
    <div className="pt__features section__padding" id="features">
      <div className="pt__features-heading">
        <h1 className="gradient__text">
          We provide a wide range of services tailored to meet your business
          needs
        </h1>
        <p>See more...</p>
      </div>
      <div className="pt__features-container">
        {featuresData.map((item, index) => (
          <Feature
            title={item.title}
            text={item.text}
            key={item.title + index}
          />
        ))}
      </div>
    </div>
  );
};

export default Features;
